<div class="modal-content-inner">
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
    </div>
    <!-- Modal body -->
    <div class="modal-body">
        <div class="modal-body-inner">
            <div class="change-status-note">
                <p class="warning-message" *ngIf="showSrdWarning">You are about to override company SRD policy. This action may have downstream impacts. Proceed only if the deviation is essential and will not adversely affect operations.</p>
                <h3 class="confirmation-text">{{ message }}</h3>
                <h4 class="confirmation-note" *ngIf="note">{{ note }}</h4>
                <div *ngIf="displayTaskFields">
                    @if (taskId) {
                        <div class="radio-buttons">
                            <label>
                                <input type="radio" name="status" value="complete"
                                       [(ngModel)]="isCheckTask"
                                       (change)="showAssignToUserList($event)">
                                Complete
                            </label>
                            <label>
                                <input type="radio" name="status" value="reassign"
                                       [(ngModel)]="isCheckTask"
                                       (change)="showAssignToUserList($event)"> Re-assigned
                            </label>
                            <label>
                                <input type="radio" name="status" value="reschedule"
                                       [(ngModel)]="isCheckTask"
                                       (change)="showAssignToUserList($event)"> Reschedule
                            </label>
                        </div>
                    }
                    <!--          <div class="email-selection-widget custom-label-checkbox"-->
                    <!--            *ngIf="(taskCategoryId == constants.TASK_CATEGORIES.CONTACTS_CONFIRM_RESPONSE && (!isCheckTask || (isCheckTask && isCheckTask !== constants.RE_ASSIGN_USER)))">-->
                    <!--            <input type="checkbox" data-md-icheck (change)="toggleClientResponseCheckbox($event)"-->
                    <!--              [checked]="isClientResponded" />-->
                    <!--            <span class="checkbox-custom">Confirm client response</span>-->
                    <!--          </div>-->

                    <!--          <div class="email-selection-widget custom-label-checkbox"-->
                    <!--            *ngIf="(taskCategoryId == constants.TASK_CATEGORIES.SAMPLE_REQUEST_HAND_DELIVER_SAMPLES_SYD_METRO && (!isCheckTask || (isCheckTask && isCheckTask !== constants.RE_ASSIGN_USER)))">-->
                    <!--            <input type="checkbox" data-md-icheck (change)="onSalesRepCheckboxChange($event)"-->
                    <!--              [checked]="isSydneyMetroAddressChecked"-->
                    <!--              [disabled]="!(currentSampleStatus === constants.SAMPLE_ORDER_REQUESTED_SHORT || currentSampleStatus === constants.SAMPLE_ORDER_PACKING_SHORT)" />-->
                    <!--            <span class="checkbox-custom">Direct to Sales Rep for Final Delivery </span>-->
                    <!--          </div>-->
                    @if (taskCategoryId == constants.TASK_CATEGORIES.OTHER_OVERPAYMENT_RECEIVED && (!isCheckTask || (isCheckTask &&
                        isCheckTask !== constants.RE_ASSIGN_USER))) {
                        <div class="radio-buttons">
                            <label>
                                <input type="radio" name="over-charged-status" value="refund"
                                       (change)="onOverchargeStatusChange($event)"
                                       [checked]="overChargeAction === 'refund'">
                                Refund
                            </label>
                            <label>
                                <input type="radio" name="over-charged-status" value="deposit-credit"
                                       (change)="onOverchargeStatusChange($event); refundInstruction = null;"
                                       [checked]="overChargeAction === 'deposit-credit'"> Deposit
                                Credit
                            </label>
                        </div>
                        @if (overChargeAction === 'refund') {
                            <div class="refund-field">
                                <input type="text" class="form-control" autocomplete="off"
                                       [(ngModel)]="refundInstruction" placeholder="Enter note">
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
        <div *ngIf="showAssignedUserList">
            <div class="popover-body-inner">
                <div class="assign-to-user-list">
                    <ng-select [items]="assignToUserList" class="custom" bindLabel="name" bindValue="id"
                               [clearable]="false"
                               [(ngModel)]="assigned_to">
                    </ng-select>
                </div>
            </div>
        </div>
        <div *ngIf="showRescheduleDatePicker" class="reschedule-date-picker">
            <div class="popover-body-inner">
                <div class="assign-to-user-list">
                    <input
                        bsDatepicker
                        [bsConfig]="{ containerClass: 'theme-default', dateInputFormat: 'DD/MM/YYYY', isAnimated: true, showWeekNumbers: false, minDate: minScheduledDate }"
                        [(ngModel)]="scheduledDate"
                        class="form-control"
                        placeholder="Select future date (DD/MM/YYYY)"
                        (keypress)="$event.preventDefault()"
                        autocomplete="off"
                        type="text">
                    <small *ngIf="scheduledDateError" style="color:red;">Please select a future date to reschedule.</small>
                </div>
            </div>
        </div>
        <div *ngIf="showRescheduleDatePicker" class="task-note-field">
            <div class="popover-body-inner">
                <div class="assign-to-user-list">
                    <label *ngIf="isTaskNoteRequired" class="task-note-label" for="task-reschedule-note">
                        Note<span class="req">*</span>
                        <span class="task-note-hint">Why is production delayed? Sales see this in the container's delay history.</span>
                    </label>
                    <textarea
                        id="task-reschedule-note"
                        class="form-control"
                        rows="3"
                        [(ngModel)]="taskNote"
                        (ngModelChange)="taskNoteError = false"
                        [placeholder]="isTaskNoteRequired ? 'Supplier could not secure the material' : 'Enter Note'"
                        autocomplete="off"></textarea>
                    <small *ngIf="taskNoteError" style="color:red;">Add a note explaining why production is delayed.</small>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer" *ngIf="!isTenderSelected && !invalidSku && !isDisplayAddProductBySkuPopup && !isDraftConfirmationPopup">
        <button type="button" class="dark-bordered-btn" data-dismiss="modal" (click)="decline()">Cancel</button>
        <button type="button" class="submit-btn-grey delete-confirmed" (click)="confirm()">{{ confirmLabel }}</button>
    </div>
    <div class="modal-footer" *ngIf="isTenderSelected || isDisplayAddProductBySkuPopup || isDraftConfirmationPopup">
        <button type="button" class="dark-bordered-btn" data-dismiss="modal" (click)="decline()">No</button>
        <button type="button" class="submit-btn-grey delete-confirmed" (click)="confirm()">Yes</button>
    </div>
    <div class="modal-footer" *ngIf="invalidSku">
        <button type="button" class="submit-btn-grey delete-confirmed" (click)="closeInvalidSkuPopup()">Okay</button>
    </div>
</div>
